import AppointmentType from "components/Atoms/AppointmentType";
import { Checkbox } from "components/Atoms/inputs/Checkbox";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  selectedTypes: server.dto.AppointmentTypes[];
  onChange: (Types: server.dto.AppointmentTypes[]) => void;
}

export const AppointmentTypeMultiPicker = ({ selectedTypes, onChange }: Props) => {
  return <div className="appointment-type-select-grid">
    {serverReference.appointmentTypes.filter(type => type.value !== "accommodation").map((type) =>
      <div key={type.value}>
        <Checkbox
          keyboardNavigationOptions={VerticalKeyboardNavigationGroup("appointmentTypes")}
          onChange={() => {
            if (selectedTypes.includes(type.value)) {
              onChange(selectedTypes.filter(p => p !== type.value));
            } else {
              onChange([...selectedTypes, type.value]);
            }
          }}
          checked={selectedTypes.includes(type.value)}
          label={<AppointmentType value={type} />}
        />
      </div>
    )}
  </div>
}